import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68582637"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view_lead_wrapper" }
const _hoisted_2 = { class: "view_lead_body" }
const _hoisted_3 = { class: "view_lead_body_title" }
const _hoisted_4 = { class: "client_title_wrapper" }
const _hoisted_5 = { class: "client_phone" }
const _hoisted_6 = {
  key: 0,
  class: "view_lead_content_wrapper"
}
const _hoisted_7 = { class: "select_block" }
const _hoisted_8 = { class: "select_wrapper" }
const _hoisted_9 = { class: "view_lead_info" }
const _hoisted_10 = {
  key: 0,
  class: "three_block_wrapper"
}
const _hoisted_11 = { class: "two_block_wrapper mt-1" }
const _hoisted_12 = { class: "left_block mb-4" }
const _hoisted_13 = { class: "right_block mb-4" }
const _hoisted_14 = { class: "w-100 mb-4" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "client_info_wrapper" }
const _hoisted_17 = { class: "mb-3 client_info" }
const _hoisted_18 = { class: "block_label" }
const _hoisted_19 = { class: "block_info" }
const _hoisted_20 = { class: "mb-3 client_info" }
const _hoisted_21 = { class: "block_label" }
const _hoisted_22 = { class: "block_info" }
const _hoisted_23 = { class: "mb-3 client_info" }
const _hoisted_24 = { class: "block_label" }
const _hoisted_25 = { class: "block_info" }
const _hoisted_26 = { class: "mb-3 client_info" }
const _hoisted_27 = { class: "block_label" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "in_club_status" }
const _hoisted_30 = { class: "mb-3 client_info" }
const _hoisted_31 = { class: "block_label" }
const _hoisted_32 = { class: "block_info" }
const _hoisted_33 = { class: "mb-3 client_info" }
const _hoisted_34 = { class: "block_label" }
const _hoisted_35 = { class: "block_info" }
const _hoisted_36 = {
  key: 0,
  class: "contract_wrapper"
}
const _hoisted_37 = { class: "contract_title flex" }
const _hoisted_38 = { class: "w-100" }
const _hoisted_39 = { class: "agreement" }
const _hoisted_40 = { class: "flex" }
const _hoisted_41 = { class: "contract" }
const _hoisted_42 = { class: "flex contract_status" }
const _hoisted_43 = {
  key: 0,
  class: "flex"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "contract_switch_button_img",
  src: "/assets/img/arrow-left.svg"
}, null, -1))
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = { class: "contract_switch_text" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "contract_switch_button_img",
  src: "/assets/img/arrow-right.svg"
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "contract_info" }
const _hoisted_50 = { class: "two_block_wrapper" }
const _hoisted_51 = { class: "left_block mb-3" }
const _hoisted_52 = { class: "block_label" }
const _hoisted_53 = { class: "block_info" }
const _hoisted_54 = { class: "right_block mb-3" }
const _hoisted_55 = { class: "block_label" }
const _hoisted_56 = { class: "block_info" }
const _hoisted_57 = { class: "two_block_wrapper" }
const _hoisted_58 = { class: "left_block mb-3" }
const _hoisted_59 = { class: "block_label" }
const _hoisted_60 = { class: "block_info" }
const _hoisted_61 = { class: "right_block mb-3" }
const _hoisted_62 = { class: "block_label" }
const _hoisted_63 = { class: "block_info" }
const _hoisted_64 = { class: "two_block_wrapper" }
const _hoisted_65 = { class: "left_block mb-3" }
const _hoisted_66 = { class: "block_label" }
const _hoisted_67 = {
  key: 0,
  class: "flex"
}
const _hoisted_68 = { class: "block_info" }
const _hoisted_69 = { class: "contract_payment_date" }
const _hoisted_70 = {
  key: 1,
  class: "flex"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "right_block mb-3" }
const _hoisted_74 = { class: "block_label" }
const _hoisted_75 = {
  key: 0,
  class: "flex"
}
const _hoisted_76 = { class: "block_info" }
const _hoisted_77 = { class: "contract_payment_date" }
const _hoisted_78 = {
  key: 1,
  class: "flex"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block_info" }, "-", -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 2,
  class: "mb-3 pl-1"
}
const _hoisted_82 = { class: "block_label" }
const _hoisted_83 = { class: "block_info" }
const _hoisted_84 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_85 = { class: "mb-4" }
const _hoisted_86 = { class: "two_block_wrapper" }
const _hoisted_87 = { class: "left_block mb-4" }
const _hoisted_88 = { class: "right_block mb-4" }
const _hoisted_89 = { class: "two_block_wrapper" }
const _hoisted_90 = { class: "left_block mb-4" }
const _hoisted_91 = { class: "right_block mb-4" }
const _hoisted_92 = { class: "position-relative" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: "/assets/img/clock.svg"
}, null, -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "view_lead_buttons_wrapper" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "view_lead_history_title" }
const _hoisted_98 = { class: "history" }
const _hoisted_99 = { class: "history_title" }
const _hoisted_100 = { class: "flex" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "history_dot" }, null, -1))
const _hoisted_102 = { class: "history_date" }
const _hoisted_103 = { class: "history_event_type" }
const _hoisted_104 = {
  key: 0,
  class: "history_description"
}
const _hoisted_105 = {
  key: 0,
  class: "audio",
  controls: "controls",
  preload: "none"
}
const _hoisted_106 = ["src"]
const _hoisted_107 = ["href"]
const _hoisted_108 = {
  key: 2,
  class: "m-0"
}
const _hoisted_109 = {
  key: 1,
  class: "view_lead_content_wrapper"
}
const _hoisted_110 = { class: "loading" }

export function render(_ctx, _cache) {
  const _component_v_input = _resolveComponent("v-input")
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_textarea = _resolveComponent("v-textarea")
  const _directive_click_outside = _resolveDirective("click-outside")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "client_photo",
          style: _normalizeStyle({ 'background-image': `url(${_ctx.photoUrl})` })
        }, null, 4),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            class: _normalizeClass(["client_name", {client_redirect: _ctx.lead?.client}]),
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.clickOnRedirect(_ctx.lead?.leadId)))
          }, _toDisplayString(_ctx.lead?.client ? `${_ctx.lead.client.lastName} ${_ctx.lead.client.firstName}` : _ctx.name), 3),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.lead?.client ? _ctx.addPhoneMask(_ctx.lead.client.phone) : _ctx.addPhoneMask(_ctx.lead?.phone)), 1)
        ])
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: _normalizeClass(_ctx.isShowInfo ? 'select_button_active' : 'select_button'),
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.isShowInfo = true))
                }, _toDisplayString(_ctx.$t('task.view.info')), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(_ctx.isShowInfo ? 'select_button' : 'select_button_active'),
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.isShowInfo = false))
                }, _toDisplayString(_ctx.$t('task.view.history')), 3)
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["view_lead", { mobile_hide: !_ctx.isShowInfo }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                (!_ctx.lead?.client)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_v_input, {
                            modelValue: _ctx.name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.name) = $event)),
                            label: _ctx.$t('task.view.name'),
                            height: "22",
                            errorText: _ctx.nameErrorText,
                            onFocus: _cache[4] || (_cache[4] = $event => (_ctx.nameErrorText = '')),
                            clearable: ""
                          }, null, 8, ["modelValue", "label", "errorText"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_v_select, {
                            class: "w-100",
                            modelValue: _ctx.selectedSex,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.selectedSex) = $event)),
                            label: 'task.view.sex',
                            items: _ctx.sex
                          }, null, 8, ["modelValue", "label", "items"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_input, {
                          modelValue: _ctx.mail,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.mail) = $event)),
                          label: _ctx.$t('task.view.mail'),
                          height: "22",
                          clearable: ""
                        }, null, 8, ["modelValue", "label"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lead?.client)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('task.view.mail')), 1),
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.lead.client.email || _ctx.$t('task.view.absent')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('task.view.birthday')), 1),
                          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.birthday, "DD MMMM yyyy") || _ctx.$t('task.view.absent')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('task.view.sex')), 1),
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.lead.client.sex ? _ctx.$t('clients.male') : _ctx.$t('clients.female')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('task.view.stay')), 1),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", {
                              class: _normalizeClass(_ctx.lead.client.inClub ? 'dot dot_active' : 'dot dot_disable')
                            }, null, 2),
                            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.lead.client.isInClub ? _ctx.$t('task.view.in_club') : _ctx.$t('task.view.not_in_club')), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t('task.view.last_in')), 1),
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.lastInDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('task.view.last_out')), 1),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.lastOutDate, "DD.MM.yyyy HH:mm") || '-'), 1)
                        ])
                      ]),
                      (_ctx.lead.client.contracts?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].agreement), 1),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].contract), 1),
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass('dot dot_contract_' + _ctx.getContractStatus(_ctx.lead.client?.contracts[_ctx.currentContractIndex].status))
                                    }, null, 2),
                                    _createTextVNode(_toDisplayString(_ctx.lead?.client ? _ctx.$t('contract_status.' + _ctx.getContractStatus(_ctx.lead.client?.contracts[_ctx.currentContractIndex].status)) : ""), 1)
                                  ])
                                ])
                              ]),
                              (_ctx.lead.client.contracts.length > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("button", {
                                      onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.previousContact && _ctx.previousContact(...args))),
                                      class: _normalizeClass(_ctx.currentContractIndex != 0 ? 'contract_switch_button mr-2' : 'contract_switch_button contract_switch_button_disabled mr-2')
                                    }, _hoisted_45, 2),
                                    _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.currentContractIndex + 1) + "/" + _toDisplayString(_ctx.lead.client?.contracts.length), 1),
                                    _createElementVNode("button", {
                                      onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.nextContact && _ctx.nextContact(...args))),
                                      class: _normalizeClass(_ctx.currentContractIndex != _ctx.lead.client?.contracts.length - 1 ? 'contract_switch_button ml-2' : 'contract_switch_button contract_switch_button_disabled ml-2')
                                    }, _hoisted_48, 2)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('task.view.start_date')), 1),
                                    _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.contracts[_ctx.currentContractIndex].startDate, "DD.MM.yyyy") || '-'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t('task.view.end_date')), 1),
                                    _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.contracts[_ctx.currentContractIndex].endDate, "DD.MM.yyyy") || '-'), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.$t('task.view.promocode')), 1),
                                    _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].referralPromocode), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t('task.view.freeze')), 1),
                                    _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t('task.view.available_days')) + ": " + _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].availableFreezingDaysNumber), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.$t('task.view.previous_payment')), 1),
                                    (_ctx.lead.client.contracts[_ctx.currentContractIndex].previousPaymentDueDate)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                          _createElementVNode("p", _hoisted_68, [
                                            _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.lead.client.contracts[_ctx.currentContractIndex].previousPaymentTotal)) + " " + _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].currencySign) + " ", 1),
                                            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.contracts[_ctx.currentContractIndex].previousPaymentDueDate, "DD.MM.yyyy") || '-'), 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_72))
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("p", _hoisted_74, _toDisplayString(_ctx.$t('task.view.next_payment')), 1),
                                    (_ctx.lead.client.contracts[_ctx.currentContractIndex].nextPaymentDueDate)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                          _createElementVNode("p", _hoisted_76, [
                                            _createTextVNode(_toDisplayString(_ctx.getFormatedAmount(_ctx.lead.client.contracts[_ctx.currentContractIndex].nextPaymentTotal)) + " " + _toDisplayString(_ctx.lead.client.contracts[_ctx.currentContractIndex].currencySign) + " ", 1),
                                            _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.getFormatedDate(_ctx.lead.client.contracts[_ctx.currentContractIndex].nextPaymentDueDate, "DD.MM.yyyy") || '-'), 1)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.lead?.openingReason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("p", _hoisted_82, _toDisplayString(_ctx.$t('task.view.opening_reason')), 1),
                      _createElementVNode("p", _hoisted_83, _toDisplayString(_ctx.lead?.openingReason), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.clubs.length > 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_v_select, {
                          class: "w-100",
                          modelValue: _ctx.selectedClub,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.selectedClub) = $event)),
                          label: 'task.view.club',
                          items: _ctx.clubs
                        }, null, 8, ["modelValue", "label", "items"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createVNode(_component_v_select, {
                      class: "w-100",
                      modelValue: _ctx.selectedStatus,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.selectedStatus) = $event)),
                      label: 'task.view.status',
                      items: _ctx.statuses,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items"])
                  ]),
                  _createElementVNode("div", _hoisted_88, [
                    _createVNode(_component_v_select, {
                      class: "w-100",
                      modelValue: _ctx.selectedManagers,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.selectedManagers) = $event)),
                      label: 'task.view.manager',
                      items: _ctx.managers,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, [
                    _createVNode(_component_v_select, {
                      class: "w-100",
                      modelValue: _ctx.selectedNextStep,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.selectedNextStep) = $event)),
                      label: 'task.view.next_step',
                      items: _ctx.nextSteps,
                      clearable: ""
                    }, null, 8, ["modelValue", "label", "items"])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_v_input, {
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.date) = $event)),
                        label: _ctx.$t('task.view.date'),
                        inputType: 'datetime-local',
                        height: "22",
                        errorText: _ctx.dateErrorText,
                        onFocus: _cache[14] || (_cache[14] = $event => (_ctx.dateErrorText = '')),
                        clearable: ""
                      }, null, 8, ["modelValue", "label", "errorText"]),
                      _createElementVNode("button", {
                        class: "now_button",
                        onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.setNowTime && _ctx.setNowTime(...args)))
                      }, _hoisted_94)
                    ])
                  ])
                ]),
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.message,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.message) = $event)),
                  label: _ctx.$t('task.view.comment')
                }, null, 8, ["modelValue", "label"])
              ]),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("button", {
                  class: "primary_button",
                  onClick: _cache[17] || (_cache[17] = (...args) => (_ctx.save && _ctx.save(...args))),
                  disabled: _ctx.isButtonDisabled
                }, _toDisplayString(_ctx.$t('task.view.save')), 9, _hoisted_96),
                _createElementVNode("button", {
                  class: "secondary_button button_space",
                  onClick: _cache[18] || (_cache[18] = $event => (_ctx.$emit('close')))
                }, _toDisplayString(_ctx.$t('task.view.cancel')), 1)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["view_lead_history", { mobile_hide: _ctx.isShowInfo }])
            }, [
              _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t('task.view.history')), 1),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.historyWrapperClass)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lead?.leadHistories, (leadHistory) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _hoisted_101,
                        _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.getFormatedDate(leadHistory.createDate, "DD.MM.yyyy HH:mm")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.$t(leadHistory.eventType)), 1)
                    ]),
                    _withDirectives(_createElementVNode("div", { class: "history_user" }, _toDisplayString(leadHistory?.userName), 513), [
                      [_vShow, leadHistory?.userName]
                    ]),
                    (leadHistory.newValue)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                          (_ctx.canPlayMp3 && (leadHistory.eventTypeId == 5 || leadHistory.eventTypeId == 6))
                            ? (_openBlock(), _createElementBlock("audio", _hoisted_105, [
                                _createElementVNode("source", {
                                  src: leadHistory.additionalData,
                                  type: "audio/mpeg"
                                }, null, 8, _hoisted_106)
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.canPlayMp3 && (leadHistory.eventTypeId == 5 || leadHistory.eventTypeId == 6))
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "download_audio",
                                href: leadHistory.additionalData,
                                download: ""
                              }, _toDisplayString(_ctx.$t('task.view.download_call')), 9, _hoisted_107))
                            : _createCommentVNode("", true),
                          (leadHistory.eventTypeId != 5 && leadHistory.eventTypeId != 6)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(leadHistory.newValue), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 256))
              ], 2)
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
            _createElementVNode("p", _hoisted_110, _toDisplayString(_ctx.$t('task.view.loading')), 1)
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_click_outside, _ctx.close]
    ])
  ]))
}